export default {
  duration: 'Laufzeit',
  recipeStepUp: 'Rezeptschritt nach oben bewegen',
  recipeStepDown: 'Rezeptschritt nach unten bewegen',
  recipeStepDuplicate: 'Rezeptschritt duplizieren',
};
